<template>
  <div>
    <!-- bác sĩ chính -->
    <div class="mb-4">
      <div class="d-flex align-items-center mb-2 pt-2">
        <div class="circle-num text-center fs-18 fw-500 txt-black me-2">1</div>
        <p class="mb-0 fs-18 fw-500 txt-black"> Bác sĩ chính</p>
      </div>
      <p class="mb-2 txt-pri fs-16">* Bác sĩ chính là Bác sĩ quyết định pháp đồ điều trị, điều trị trực tiếp, trường phó đơn vị</p>
      <div
        class="doctor-item"
        v-if="main_doctor"
        :set="dtr = main_doctor.doctor"
      >
        <div class="mb-2 d-flex">
          <div class="d-info-avatar">
            <img
              v-if="!dtr.user || !dtr.user.avatar"
              src="/images/common/df-avatar.svg"
              alt=""
              class="avatar"
            >
            <img
              v-if="dtr.user && dtr.user.avatar"
              :src="getUrlImage(dtr.user.avatar)"
              alt=""
              class="avatar"
            >
            <p class="fs-18 fw-500 txt-black">{{dtr.name}}</p>
          </div>
          <div class="d-status">
            <p
              class="mb-1 fs-12"
              :class="main_doctor.is_accepted === 0 ? 'text-danger' : main_doctor.is_accepted === 1 ? 'text-success' : 'text-danger'"
            >{{main_doctor.is_accepted === 0 ? 'Đang chờ' : main_doctor.is_accepted === 1 ? 'Đã kết nối' : 'Đã từ chối'}}</p>
            <div
              class="d-flex align-items-center c-pointer"
              @click="onSelectDoctor(1)"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="me-1"
              >
                <path
                  d="M10.0003 1.66602C5.40033 1.66602 1.66699 5.39935 1.66699 9.99935C1.66699 14.5993 5.40033 18.3327 10.0003 18.3327C14.6003 18.3327 18.3337 14.5993 18.3337 9.99935C18.3337 5.39935 14.6003 1.66602 10.0003 1.66602ZM5.50033 9.35768C5.64199 8.36601 6.08366 7.47435 6.77533 6.77435C8.44199 5.11602 11.067 5.02435 12.8503 6.47435V5.68268C12.8503 5.34102 13.1337 5.05768 13.4753 5.05768C13.817 5.05768 14.1003 5.34102 14.1003 5.68268V7.90768C14.1003 8.24935 13.817 8.53268 13.4753 8.53268H11.2503C10.9087 8.53268 10.6253 8.24935 10.6253 7.90768C10.6253 7.56602 10.9087 7.28268 11.2503 7.28268H11.8753C10.5837 6.38268 8.80033 6.50768 7.65033 7.65768C7.15033 8.15768 6.83366 8.80768 6.72533 9.53268C6.68366 9.84101 6.41699 10.066 6.10866 10.066C6.07533 10.066 6.05033 10.066 6.01699 10.0577C5.69199 10.016 5.45033 9.69935 5.50033 9.35768ZM13.2253 13.2243C12.3337 14.116 11.167 14.5577 10.0003 14.5577C8.98366 14.5577 7.97533 14.1993 7.14199 13.5243V14.3077C7.14199 14.6493 6.85866 14.9327 6.51699 14.9327C6.17533 14.9327 5.89199 14.6493 5.89199 14.3077V12.0827C5.89199 11.741 6.17533 11.4577 6.51699 11.4577H8.74199C9.08366 11.4577 9.36699 11.741 9.36699 12.0827C9.36699 12.4243 9.08366 12.7077 8.74199 12.7077H8.11699C9.40866 13.6077 11.192 13.4827 12.342 12.3327C12.842 11.8327 13.1587 11.1827 13.267 10.4577C13.317 10.116 13.6253 9.87435 13.9753 9.92435C14.317 9.97435 14.5503 10.291 14.5087 10.6327C14.3587 11.641 13.917 12.5327 13.2253 13.2243Z"
                  fill="#A1A1A1"
                />
              </svg>

              <p class="mb-0 fs-12 txt-gray-blur">Thay đổi</p>
            </div>
          </div>
        </div>
        <div class="info">
          <div class="d-flex mb-1">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="me-1"
            >
              <path
                d="M5.33338 14.6667H10.6667C13.3467 14.6667 13.8267 13.5933 13.9667 12.2867L14.4667 6.95333C14.6467 5.32667 14.18 4 11.3334 4H4.66671C1.82005 4 1.35338 5.32667 1.53338 6.95333L2.03338 12.2867C2.17338 13.5933 2.65338 14.6667 5.33338 14.6667Z"
                stroke="#476DD6"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.33337 3.99967V3.46634C5.33337 2.28634 5.33337 1.33301 7.46671 1.33301H8.53337C10.6667 1.33301 10.6667 2.28634 10.6667 3.46634V3.99967"
                stroke="#476DD6"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.33329 8.66667V9.33333C9.33329 9.34 9.33329 9.34 9.33329 9.34667C9.33329 10.0733 9.32663 10.6667 7.99996 10.6667C6.67996 10.6667 6.66663 10.08 6.66663 9.35333V8.66667C6.66663 8 6.66663 8 7.33329 8H8.66663C9.33329 8 9.33329 8 9.33329 8.66667Z"
                stroke="#476DD6"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.4334 7.33301C12.8934 8.45301 11.1334 9.11967 9.33337 9.34634"
                stroke="#476DD6"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.7467 7.51367C3.2467 8.54034 4.94004 9.16034 6.6667 9.35367"
                stroke="#476DD6"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <p class="mb-0 fs-12 txt-black text-doctor-info max-line-2">{{dtr.chuc_vu || 'Chưa cập nhật'}}</p>
          </div>
          <div class="d-flex mb-1">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="me-1"
            >
              <path
                d="M8.00004 8.95297C9.1488 8.95297 10.08 8.02172 10.08 6.87297C10.08 5.72422 9.1488 4.79297 8.00004 4.79297C6.85129 4.79297 5.92004 5.72422 5.92004 6.87297C5.92004 8.02172 6.85129 8.95297 8.00004 8.95297Z"
                stroke="#476DD6"
                stroke-width="1.5"
              />
              <path
                d="M2.4133 5.65968C3.72664 -0.113657 12.28 -0.106991 13.5866 5.66634C14.3533 9.05301 12.2466 11.9197 10.4 13.693C9.05997 14.9863 6.93997 14.9863 5.5933 13.693C3.7533 11.9197 1.64664 9.04634 2.4133 5.65968Z"
                stroke="#476DD6"
                stroke-width="1.5"
              />
            </svg>

            <p class="mb-0 fs-12 txt-black text-doctor-info max-line-2">{{dtr.address || 'Chưa cập nhật'}}</p>
          </div>
          <div class="d-flex mb-1">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="me-1"
            >
              <path
                d="M12.6667 5.33301C12.1954 5.33183 11.7388 5.49757 11.378 5.80087C11.0172 6.10416 10.7754 6.52541 10.6955 6.98994C10.6157 7.45447 10.7028 7.93229 10.9416 8.33868C11.1804 8.74507 11.5554 9.05379 12 9.21012V10.333C12 11.1287 11.684 11.8917 11.1214 12.4543C10.5588 13.0169 9.79569 13.333 9.00004 13.333C8.20439 13.333 7.44133 13.0169 6.87872 12.4543C6.31611 11.8917 6.00004 11.1287 6.00004 10.333V9.93946C6.93112 9.78147 7.77636 9.29939 8.38634 8.57843C8.99633 7.85747 9.33177 6.94406 9.33337 5.99967V1.99967C9.33337 1.82286 9.26314 1.65329 9.13811 1.52827C9.01309 1.40325 8.84352 1.33301 8.66671 1.33301H7.33337C7.15656 1.33301 6.98699 1.40325 6.86197 1.52827C6.73695 1.65329 6.66671 1.82286 6.66671 1.99967C6.66671 2.17649 6.73695 2.34605 6.86197 2.47108C6.98699 2.5961 7.15656 2.66634 7.33337 2.66634H8.00004V5.99967C8.00004 6.70692 7.71909 7.3852 7.21899 7.88529C6.7189 8.38539 6.04062 8.66634 5.33337 8.66634C4.62613 8.66634 3.94785 8.38539 3.44776 7.88529C2.94766 7.3852 2.66671 6.70692 2.66671 5.99967V2.66634H3.33337C3.51019 2.66634 3.67975 2.5961 3.80478 2.47108C3.9298 2.34605 4.00004 2.17649 4.00004 1.99967C4.00004 1.82286 3.9298 1.65329 3.80478 1.52827C3.67975 1.40325 3.51019 1.33301 3.33337 1.33301H2.00004C1.82323 1.33301 1.65366 1.40325 1.52864 1.52827C1.40361 1.65329 1.33337 1.82286 1.33337 1.99967V5.99967C1.33498 6.94406 1.67042 7.85747 2.2804 8.57843C2.89039 9.29939 3.73563 9.78147 4.66671 9.93946V10.333C4.66671 11.4823 5.12325 12.5845 5.93591 13.3971C6.74857 14.2098 7.85077 14.6663 9.00004 14.6663C10.1493 14.6663 11.2515 14.2098 12.0642 13.3971C12.8768 12.5845 13.3334 11.4823 13.3334 10.333V9.21016C13.778 9.05383 14.153 8.7451 14.3918 8.3387C14.6306 7.93231 14.7177 7.4545 14.6379 6.98997C14.558 6.52543 14.3162 6.10418 13.9554 5.80089C13.5946 5.49759 13.1381 5.33184 12.6667 5.33301ZM12.6667 7.99967C12.5349 7.99967 12.406 7.96058 12.2963 7.88732C12.1867 7.81407 12.1012 7.70995 12.0508 7.58813C12.0003 7.46631 11.9871 7.33227 12.0129 7.20295C12.0386 7.07363 12.1021 6.95484 12.1953 6.8616C12.2885 6.76837 12.4073 6.70487 12.5366 6.67915C12.666 6.65343 12.8 6.66663 12.9218 6.71709C13.0436 6.76755 13.1478 6.85299 13.221 6.96263C13.2943 7.07226 13.3334 7.20115 13.3334 7.33301C13.3331 7.50975 13.2628 7.67918 13.1379 7.80416C13.0129 7.92913 12.8434 7.99945 12.6667 7.99967Z"
                fill="#476DD6"
              />
            </svg>

            <p class="mb-0 fs-12 txt-pri text-doctor-info max-line-2">{{dtr.majors || 'Chưa cập nhật'}}</p>
          </div>
        </div>
      </div>
      <div v-if="!main_doctor">
        <div
          class="doctor-add-btn"
          @
          @click="onSelectDoctor(1)"
        >
          <svg
            width="29"
            height="28"
            viewBox="0 0 29 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.4997 25.6663C8.05635 25.6663 2.83301 20.443 2.83301 13.9997C2.83301 7.55635 8.05635 2.33301 14.4997 2.33301C20.943 2.33301 26.1663 7.55635 26.1663 13.9997C26.1663 20.443 20.943 25.6663 14.4997 25.6663ZM14.4997 4.66634C9.34502 4.66634 5.16634 8.84502 5.16634 13.9997C5.16634 19.1543 9.34502 23.333 14.4997 23.333C19.6543 23.333 23.833 19.1543 23.833 13.9997C23.833 8.84502 19.6543 4.66634 14.4997 4.66634ZM14.5002 7.88326C15.1445 7.88326 15.6669 8.4056 15.6669 9.04993V12.833H19.4494C20.0938 12.833 20.6161 13.3553 20.6161 13.9997C20.6161 14.644 20.0938 15.1663 19.4494 15.1663H15.6669V18.9494C15.6669 19.5938 15.1445 20.1161 14.5002 20.1161C13.8559 20.1161 13.3335 19.5938 13.3335 18.9494V15.1663H9.54993C8.9056 15.1663 8.38326 14.644 8.38326 13.9997C8.38326 13.3553 8.9056 12.833 9.54993 12.833H13.3335V9.04993C13.3335 8.4056 13.8559 7.88326 14.5002 7.88326ZM15.6669 13.283C15.4183 13.283 15.2169 13.0815 15.2169 12.833V9.04993C15.2169 8.65412 14.896 8.33326 14.5002 8.33326C14.1044 8.33326 13.7835 8.65412 13.7835 9.04993V12.833C13.7835 13.0815 13.5821 13.283 13.3335 13.283H9.54993C9.15412 13.283 8.83326 13.6039 8.83326 13.9997C8.83326 14.3955 9.15412 14.7163 9.54993 14.7163H13.3335C13.5821 14.7163 13.7835 14.9178 13.7835 15.1663V18.9494C13.7835 19.3452 14.1044 19.6661 14.5002 19.6661C14.896 19.6661 15.2169 19.3452 15.2169 18.9494V15.1663C15.2169 14.9178 15.4183 14.7163 15.6669 14.7163H19.4494C19.8452 14.7163 20.1661 14.3955 20.1661 13.9997C20.1661 13.6039 19.8452 13.283 19.4494 13.283H15.6669ZM3.28301 13.9997C3.28301 20.1945 8.30488 25.2163 14.4997 25.2163C20.6945 25.2163 25.7163 20.1945 25.7163 13.9997C25.7163 7.80488 20.6945 2.78301 14.4997 2.78301C8.30488 2.78301 3.28301 7.80488 3.28301 13.9997ZM4.71634 13.9997C4.71634 8.59649 9.09649 4.21634 14.4997 4.21634C19.9029 4.21634 24.283 8.59649 24.283 13.9997C24.283 19.4029 19.9029 23.783 14.4997 23.783C9.09649 23.783 4.71634 19.4029 4.71634 13.9997ZM2.83301 13.9997C2.83301 20.443 8.05635 25.6663 14.4997 25.6663C20.943 25.6663 26.1663 20.443 26.1663 13.9997C26.1663 7.55635 20.943 2.33301 14.4997 2.33301C8.05635 2.33301 2.83301 7.55635 2.83301 13.9997ZM5.16634 13.9997C5.16634 8.84502 9.34502 4.66634 14.4997 4.66634C19.6543 4.66634 23.833 8.84502 23.833 13.9997C23.833 19.1543 19.6543 23.333 14.4997 23.333C9.34502 23.333 5.16634 19.1543 5.16634 13.9997ZM15.6669 9.04993C15.6669 8.4056 15.1445 7.88326 14.5002 7.88326C13.8559 7.88326 13.3335 8.4056 13.3335 9.04993V12.833H9.54993C8.9056 12.833 8.38326 13.3553 8.38326 13.9997C8.38326 14.644 8.9056 15.1663 9.54993 15.1663H13.3335V18.9494C13.3335 19.5938 13.8559 20.1161 14.5002 20.1161C15.1445 20.1161 15.6669 19.5938 15.6669 18.9494V15.1663H19.4494C20.0938 15.1663 20.6161 14.644 20.6161 13.9997C20.6161 13.3553 20.0938 12.833 19.4494 12.833H15.6669V9.04993Z"
              fill="#20409B"
            />
          </svg>
          <p class="mb-0 txt-pri fs-16">Thêm</p>
        </div>
      </div>

    </div>
    <!-- Điều trị -->
    <div class="d-flex align-items-center mb-2 pt-2">
      <div class="circle-num text-center fs-18 fw-500 txt-black me-2">2</div>
      <p class="mb-0 fs-18 fw-500 txt-black"> Bác sĩ điều trị</p>
    </div>
    <p class="mb-2 txt-pri fs-16">* Bác sĩ trực tiếp điều trị</p>

    <div
      class="mb-3"
      v-if="doctors"
    >
      <div
        class="doctor-item"
        v-for="ctdtr in doctors"
        :key="ctdtr.id"
        :set="dtr = ctdtr.doctor"
      >
        <div class="mb-2 d-flex">
          <div class="d-info-avatar">
            <img
              v-if="!dtr.user || !dtr.user.avatar"
              src="/images/common/df-avatar.svg"
              alt=""
              class="avatar"
            >
            <img
              v-if="dtr.user && dtr.user.avatar"
              :src="getUrlImage(dtr.user.avatar)"
              alt=""
              class="avatar"
            >
            <p class="fs-18 fw-500 txt-black">{{dtr.name}}</p>
          </div>
          <div class="d-status">
            <p
              class="mb-1 fs-12"
              :class="ctdtr.is_accepted === 0 ? 'text-danger' : ctdtr.is_accepted === 1 ? 'text-success' : 'text-danger'"
            >{{ctdtr.is_accepted === 0 ? 'Đang chờ' : ctdtr.is_accepted === 1 ? 'Đã kết nối' : 'Đã từ chối'}}</p>
            <div
              class="d-flex align-items-center c-pointer"
              @click="onDeleteDoctor(ctdtr)"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="me-1"
              >
                <path
                  d="M17.5 4.98405C14.725 4.70905 11.9333 4.56738 9.15 4.56738C7.5 4.56738 5.85 4.65072 4.2 4.81738L2.5 4.98405"
                  stroke="#A1A1A1"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.0835 4.14199L7.26683 3.05033C7.40016 2.25866 7.50016 1.66699 8.9085 1.66699H11.0918C12.5002 1.66699 12.6085 2.29199 12.7335 3.05866L12.9168 4.14199"
                  stroke="#A1A1A1"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.7087 7.61621L15.167 16.0079C15.0753 17.3162 15.0003 18.3329 12.6753 18.3329H7.32533C5.00033 18.3329 4.92533 17.3162 4.83366 16.0079L4.29199 7.61621"
                  stroke="#A1A1A1"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.6084 13.75H11.3834"
                  stroke="#A1A1A1"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.9165 10.417H12.0832"
                  stroke="#A1A1A1"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <p class="mb-0 fs-12 txt-gray-blur">Xóa</p>
            </div>
          </div>
        </div>
        <div class="info">
          <div class="d-flex mb-1">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="me-1"
            >
              <path
                d="M5.33338 14.6667H10.6667C13.3467 14.6667 13.8267 13.5933 13.9667 12.2867L14.4667 6.95333C14.6467 5.32667 14.18 4 11.3334 4H4.66671C1.82005 4 1.35338 5.32667 1.53338 6.95333L2.03338 12.2867C2.17338 13.5933 2.65338 14.6667 5.33338 14.6667Z"
                stroke="#476DD6"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.33337 3.99967V3.46634C5.33337 2.28634 5.33337 1.33301 7.46671 1.33301H8.53337C10.6667 1.33301 10.6667 2.28634 10.6667 3.46634V3.99967"
                stroke="#476DD6"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.33329 8.66667V9.33333C9.33329 9.34 9.33329 9.34 9.33329 9.34667C9.33329 10.0733 9.32663 10.6667 7.99996 10.6667C6.67996 10.6667 6.66663 10.08 6.66663 9.35333V8.66667C6.66663 8 6.66663 8 7.33329 8H8.66663C9.33329 8 9.33329 8 9.33329 8.66667Z"
                stroke="#476DD6"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.4334 7.33301C12.8934 8.45301 11.1334 9.11967 9.33337 9.34634"
                stroke="#476DD6"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.7467 7.51367C3.2467 8.54034 4.94004 9.16034 6.6667 9.35367"
                stroke="#476DD6"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <p class="mb-0 fs-12 txt-black text-doctor-info max-line-2">{{dtr.chuc_vu || 'Chưa cập nhật'}}</p>
          </div>
          <div class="d-flex mb-1">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="me-1"
            >
              <path
                d="M8.00004 8.95297C9.1488 8.95297 10.08 8.02172 10.08 6.87297C10.08 5.72422 9.1488 4.79297 8.00004 4.79297C6.85129 4.79297 5.92004 5.72422 5.92004 6.87297C5.92004 8.02172 6.85129 8.95297 8.00004 8.95297Z"
                stroke="#476DD6"
                stroke-width="1.5"
              />
              <path
                d="M2.4133 5.65968C3.72664 -0.113657 12.28 -0.106991 13.5866 5.66634C14.3533 9.05301 12.2466 11.9197 10.4 13.693C9.05997 14.9863 6.93997 14.9863 5.5933 13.693C3.7533 11.9197 1.64664 9.04634 2.4133 5.65968Z"
                stroke="#476DD6"
                stroke-width="1.5"
              />
            </svg>

            <p class="mb-0 fs-12 txt-black text-doctor-info max-line-2">{{dtr.address || 'Chưa cập nhật'}}</p>
          </div>
          <div class="d-flex mb-1">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="me-1"
            >
              <path
                d="M12.6667 5.33301C12.1954 5.33183 11.7388 5.49757 11.378 5.80087C11.0172 6.10416 10.7754 6.52541 10.6955 6.98994C10.6157 7.45447 10.7028 7.93229 10.9416 8.33868C11.1804 8.74507 11.5554 9.05379 12 9.21012V10.333C12 11.1287 11.684 11.8917 11.1214 12.4543C10.5588 13.0169 9.79569 13.333 9.00004 13.333C8.20439 13.333 7.44133 13.0169 6.87872 12.4543C6.31611 11.8917 6.00004 11.1287 6.00004 10.333V9.93946C6.93112 9.78147 7.77636 9.29939 8.38634 8.57843C8.99633 7.85747 9.33177 6.94406 9.33337 5.99967V1.99967C9.33337 1.82286 9.26314 1.65329 9.13811 1.52827C9.01309 1.40325 8.84352 1.33301 8.66671 1.33301H7.33337C7.15656 1.33301 6.98699 1.40325 6.86197 1.52827C6.73695 1.65329 6.66671 1.82286 6.66671 1.99967C6.66671 2.17649 6.73695 2.34605 6.86197 2.47108C6.98699 2.5961 7.15656 2.66634 7.33337 2.66634H8.00004V5.99967C8.00004 6.70692 7.71909 7.3852 7.21899 7.88529C6.7189 8.38539 6.04062 8.66634 5.33337 8.66634C4.62613 8.66634 3.94785 8.38539 3.44776 7.88529C2.94766 7.3852 2.66671 6.70692 2.66671 5.99967V2.66634H3.33337C3.51019 2.66634 3.67975 2.5961 3.80478 2.47108C3.9298 2.34605 4.00004 2.17649 4.00004 1.99967C4.00004 1.82286 3.9298 1.65329 3.80478 1.52827C3.67975 1.40325 3.51019 1.33301 3.33337 1.33301H2.00004C1.82323 1.33301 1.65366 1.40325 1.52864 1.52827C1.40361 1.65329 1.33337 1.82286 1.33337 1.99967V5.99967C1.33498 6.94406 1.67042 7.85747 2.2804 8.57843C2.89039 9.29939 3.73563 9.78147 4.66671 9.93946V10.333C4.66671 11.4823 5.12325 12.5845 5.93591 13.3971C6.74857 14.2098 7.85077 14.6663 9.00004 14.6663C10.1493 14.6663 11.2515 14.2098 12.0642 13.3971C12.8768 12.5845 13.3334 11.4823 13.3334 10.333V9.21016C13.778 9.05383 14.153 8.7451 14.3918 8.3387C14.6306 7.93231 14.7177 7.4545 14.6379 6.98997C14.558 6.52543 14.3162 6.10418 13.9554 5.80089C13.5946 5.49759 13.1381 5.33184 12.6667 5.33301ZM12.6667 7.99967C12.5349 7.99967 12.406 7.96058 12.2963 7.88732C12.1867 7.81407 12.1012 7.70995 12.0508 7.58813C12.0003 7.46631 11.9871 7.33227 12.0129 7.20295C12.0386 7.07363 12.1021 6.95484 12.1953 6.8616C12.2885 6.76837 12.4073 6.70487 12.5366 6.67915C12.666 6.65343 12.8 6.66663 12.9218 6.71709C13.0436 6.76755 13.1478 6.85299 13.221 6.96263C13.2943 7.07226 13.3334 7.20115 13.3334 7.33301C13.3331 7.50975 13.2628 7.67918 13.1379 7.80416C13.0129 7.92913 12.8434 7.99945 12.6667 7.99967Z"
                fill="#476DD6"
              />
            </svg>

            <p class="mb-0 fs-12 txt-pri text-doctor-info max-line-2">{{dtr.majors || 'Chưa cập nhật'}}</p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="mb-4"
      @click="onSelectDoctor(4)"
    >
      <div class="doctor-add-btn">
        <svg
          width="29"
          height="28"
          viewBox="0 0 29 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.4997 25.6663C8.05635 25.6663 2.83301 20.443 2.83301 13.9997C2.83301 7.55635 8.05635 2.33301 14.4997 2.33301C20.943 2.33301 26.1663 7.55635 26.1663 13.9997C26.1663 20.443 20.943 25.6663 14.4997 25.6663ZM14.4997 4.66634C9.34502 4.66634 5.16634 8.84502 5.16634 13.9997C5.16634 19.1543 9.34502 23.333 14.4997 23.333C19.6543 23.333 23.833 19.1543 23.833 13.9997C23.833 8.84502 19.6543 4.66634 14.4997 4.66634ZM14.5002 7.88326C15.1445 7.88326 15.6669 8.4056 15.6669 9.04993V12.833H19.4494C20.0938 12.833 20.6161 13.3553 20.6161 13.9997C20.6161 14.644 20.0938 15.1663 19.4494 15.1663H15.6669V18.9494C15.6669 19.5938 15.1445 20.1161 14.5002 20.1161C13.8559 20.1161 13.3335 19.5938 13.3335 18.9494V15.1663H9.54993C8.9056 15.1663 8.38326 14.644 8.38326 13.9997C8.38326 13.3553 8.9056 12.833 9.54993 12.833H13.3335V9.04993C13.3335 8.4056 13.8559 7.88326 14.5002 7.88326ZM15.6669 13.283C15.4183 13.283 15.2169 13.0815 15.2169 12.833V9.04993C15.2169 8.65412 14.896 8.33326 14.5002 8.33326C14.1044 8.33326 13.7835 8.65412 13.7835 9.04993V12.833C13.7835 13.0815 13.5821 13.283 13.3335 13.283H9.54993C9.15412 13.283 8.83326 13.6039 8.83326 13.9997C8.83326 14.3955 9.15412 14.7163 9.54993 14.7163H13.3335C13.5821 14.7163 13.7835 14.9178 13.7835 15.1663V18.9494C13.7835 19.3452 14.1044 19.6661 14.5002 19.6661C14.896 19.6661 15.2169 19.3452 15.2169 18.9494V15.1663C15.2169 14.9178 15.4183 14.7163 15.6669 14.7163H19.4494C19.8452 14.7163 20.1661 14.3955 20.1661 13.9997C20.1661 13.6039 19.8452 13.283 19.4494 13.283H15.6669ZM3.28301 13.9997C3.28301 20.1945 8.30488 25.2163 14.4997 25.2163C20.6945 25.2163 25.7163 20.1945 25.7163 13.9997C25.7163 7.80488 20.6945 2.78301 14.4997 2.78301C8.30488 2.78301 3.28301 7.80488 3.28301 13.9997ZM4.71634 13.9997C4.71634 8.59649 9.09649 4.21634 14.4997 4.21634C19.9029 4.21634 24.283 8.59649 24.283 13.9997C24.283 19.4029 19.9029 23.783 14.4997 23.783C9.09649 23.783 4.71634 19.4029 4.71634 13.9997ZM2.83301 13.9997C2.83301 20.443 8.05635 25.6663 14.4997 25.6663C20.943 25.6663 26.1663 20.443 26.1663 13.9997C26.1663 7.55635 20.943 2.33301 14.4997 2.33301C8.05635 2.33301 2.83301 7.55635 2.83301 13.9997ZM5.16634 13.9997C5.16634 8.84502 9.34502 4.66634 14.4997 4.66634C19.6543 4.66634 23.833 8.84502 23.833 13.9997C23.833 19.1543 19.6543 23.333 14.4997 23.333C9.34502 23.333 5.16634 19.1543 5.16634 13.9997ZM15.6669 9.04993C15.6669 8.4056 15.1445 7.88326 14.5002 7.88326C13.8559 7.88326 13.3335 8.4056 13.3335 9.04993V12.833H9.54993C8.9056 12.833 8.38326 13.3553 8.38326 13.9997C8.38326 14.644 8.9056 15.1663 9.54993 15.1663H13.3335V18.9494C13.3335 19.5938 13.8559 20.1161 14.5002 20.1161C15.1445 20.1161 15.6669 19.5938 15.6669 18.9494V15.1663H19.4494C20.0938 15.1663 20.6161 14.644 20.6161 13.9997C20.6161 13.3553 20.0938 12.833 19.4494 12.833H15.6669V9.04993Z"
            fill="#20409B"
          />
        </svg>
        <p class="mb-0 txt-pri fs-16">Thêm</p>
      </div>
    </div>
    <!-- người hỗ trợ -->

    <div class="d-flex align-items-center mb-2 pt-2">
      <div class="circle-num text-center fs-18 fw-500 txt-black me-2">3</div>
      <p class="mb-0 fs-18 fw-500 txt-black"> Người hỗ trợ</p>
    </div>
    <div
      class="mb-3"
      v-if="supporters"
    >
      <div
        class="doctor-item"
        v-for="ctdtr in supporters"
        :key="ctdtr.id"
        :set="dtr = ctdtr.doctor"
      >
        <div class="mb-2 d-flex">
          <div class="d-info-avatar">
            <img
              v-if="!dtr.user || !dtr.user.avatar"
              src="/images/common/df-avatar.svg"
              alt=""
              class="avatar"
            >
            <img
              v-if="dtr.user && dtr.user.avatar"
              :src="getUrlImage(dtr.user.avatar)"
              alt=""
              class="avatar"
            >
            <p class="fs-18 fw-500 txt-black">{{dtr.name}}</p>
          </div>
          <div class="d-status">
            <p
              class="mb-1 fs-12"
              :class="ctdtr.is_accepted === 0 ? 'text-danger' : ctdtr.is_accepted === 1 ? 'text-success' : 'text-danger'"
            >{{ctdtr.is_accepted === 0 ? 'Đang chờ' : ctdtr.is_accepted === 1 ? 'Đã kết nối' : 'Đã từ chối'}}</p>
            <div
              class="d-flex align-items-center c-pointer"
              @click="onDeleteDoctor(ctdtr)"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="me-1"
              >
                <path
                  d="M17.5 4.98405C14.725 4.70905 11.9333 4.56738 9.15 4.56738C7.5 4.56738 5.85 4.65072 4.2 4.81738L2.5 4.98405"
                  stroke="#A1A1A1"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.0835 4.14199L7.26683 3.05033C7.40016 2.25866 7.50016 1.66699 8.9085 1.66699H11.0918C12.5002 1.66699 12.6085 2.29199 12.7335 3.05866L12.9168 4.14199"
                  stroke="#A1A1A1"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.7087 7.61621L15.167 16.0079C15.0753 17.3162 15.0003 18.3329 12.6753 18.3329H7.32533C5.00033 18.3329 4.92533 17.3162 4.83366 16.0079L4.29199 7.61621"
                  stroke="#A1A1A1"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.6084 13.75H11.3834"
                  stroke="#A1A1A1"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.9165 10.417H12.0832"
                  stroke="#A1A1A1"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <p class="mb-0 fs-12 txt-gray-blur">Xóa</p>
            </div>
          </div>
        </div>
        <div class="info">
          <div class="d-flex mb-1">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="me-1"
            >
              <path
                d="M5.33338 14.6667H10.6667C13.3467 14.6667 13.8267 13.5933 13.9667 12.2867L14.4667 6.95333C14.6467 5.32667 14.18 4 11.3334 4H4.66671C1.82005 4 1.35338 5.32667 1.53338 6.95333L2.03338 12.2867C2.17338 13.5933 2.65338 14.6667 5.33338 14.6667Z"
                stroke="#476DD6"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.33337 3.99967V3.46634C5.33337 2.28634 5.33337 1.33301 7.46671 1.33301H8.53337C10.6667 1.33301 10.6667 2.28634 10.6667 3.46634V3.99967"
                stroke="#476DD6"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.33329 8.66667V9.33333C9.33329 9.34 9.33329 9.34 9.33329 9.34667C9.33329 10.0733 9.32663 10.6667 7.99996 10.6667C6.67996 10.6667 6.66663 10.08 6.66663 9.35333V8.66667C6.66663 8 6.66663 8 7.33329 8H8.66663C9.33329 8 9.33329 8 9.33329 8.66667Z"
                stroke="#476DD6"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.4334 7.33301C12.8934 8.45301 11.1334 9.11967 9.33337 9.34634"
                stroke="#476DD6"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.7467 7.51367C3.2467 8.54034 4.94004 9.16034 6.6667 9.35367"
                stroke="#476DD6"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <p class="mb-0 fs-12 txt-black text-doctor-info max-line-2">{{dtr.chuc_vu || 'Chưa cập nhật'}}</p>
          </div>
          <div class="d-flex mb-1">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="me-1"
            >
              <path
                d="M8.00004 8.95297C9.1488 8.95297 10.08 8.02172 10.08 6.87297C10.08 5.72422 9.1488 4.79297 8.00004 4.79297C6.85129 4.79297 5.92004 5.72422 5.92004 6.87297C5.92004 8.02172 6.85129 8.95297 8.00004 8.95297Z"
                stroke="#476DD6"
                stroke-width="1.5"
              />
              <path
                d="M2.4133 5.65968C3.72664 -0.113657 12.28 -0.106991 13.5866 5.66634C14.3533 9.05301 12.2466 11.9197 10.4 13.693C9.05997 14.9863 6.93997 14.9863 5.5933 13.693C3.7533 11.9197 1.64664 9.04634 2.4133 5.65968Z"
                stroke="#476DD6"
                stroke-width="1.5"
              />
            </svg>

            <p class="mb-0 fs-12 txt-black text-doctor-info max-line-2">{{dtr.address || 'Chưa cập nhật'}}</p>
          </div>
          <div class="d-flex mb-1">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="me-1"
            >
              <path
                d="M12.6667 5.33301C12.1954 5.33183 11.7388 5.49757 11.378 5.80087C11.0172 6.10416 10.7754 6.52541 10.6955 6.98994C10.6157 7.45447 10.7028 7.93229 10.9416 8.33868C11.1804 8.74507 11.5554 9.05379 12 9.21012V10.333C12 11.1287 11.684 11.8917 11.1214 12.4543C10.5588 13.0169 9.79569 13.333 9.00004 13.333C8.20439 13.333 7.44133 13.0169 6.87872 12.4543C6.31611 11.8917 6.00004 11.1287 6.00004 10.333V9.93946C6.93112 9.78147 7.77636 9.29939 8.38634 8.57843C8.99633 7.85747 9.33177 6.94406 9.33337 5.99967V1.99967C9.33337 1.82286 9.26314 1.65329 9.13811 1.52827C9.01309 1.40325 8.84352 1.33301 8.66671 1.33301H7.33337C7.15656 1.33301 6.98699 1.40325 6.86197 1.52827C6.73695 1.65329 6.66671 1.82286 6.66671 1.99967C6.66671 2.17649 6.73695 2.34605 6.86197 2.47108C6.98699 2.5961 7.15656 2.66634 7.33337 2.66634H8.00004V5.99967C8.00004 6.70692 7.71909 7.3852 7.21899 7.88529C6.7189 8.38539 6.04062 8.66634 5.33337 8.66634C4.62613 8.66634 3.94785 8.38539 3.44776 7.88529C2.94766 7.3852 2.66671 6.70692 2.66671 5.99967V2.66634H3.33337C3.51019 2.66634 3.67975 2.5961 3.80478 2.47108C3.9298 2.34605 4.00004 2.17649 4.00004 1.99967C4.00004 1.82286 3.9298 1.65329 3.80478 1.52827C3.67975 1.40325 3.51019 1.33301 3.33337 1.33301H2.00004C1.82323 1.33301 1.65366 1.40325 1.52864 1.52827C1.40361 1.65329 1.33337 1.82286 1.33337 1.99967V5.99967C1.33498 6.94406 1.67042 7.85747 2.2804 8.57843C2.89039 9.29939 3.73563 9.78147 4.66671 9.93946V10.333C4.66671 11.4823 5.12325 12.5845 5.93591 13.3971C6.74857 14.2098 7.85077 14.6663 9.00004 14.6663C10.1493 14.6663 11.2515 14.2098 12.0642 13.3971C12.8768 12.5845 13.3334 11.4823 13.3334 10.333V9.21016C13.778 9.05383 14.153 8.7451 14.3918 8.3387C14.6306 7.93231 14.7177 7.4545 14.6379 6.98997C14.558 6.52543 14.3162 6.10418 13.9554 5.80089C13.5946 5.49759 13.1381 5.33184 12.6667 5.33301ZM12.6667 7.99967C12.5349 7.99967 12.406 7.96058 12.2963 7.88732C12.1867 7.81407 12.1012 7.70995 12.0508 7.58813C12.0003 7.46631 11.9871 7.33227 12.0129 7.20295C12.0386 7.07363 12.1021 6.95484 12.1953 6.8616C12.2885 6.76837 12.4073 6.70487 12.5366 6.67915C12.666 6.65343 12.8 6.66663 12.9218 6.71709C13.0436 6.76755 13.1478 6.85299 13.221 6.96263C13.2943 7.07226 13.3334 7.20115 13.3334 7.33301C13.3331 7.50975 13.2628 7.67918 13.1379 7.80416C13.0129 7.92913 12.8434 7.99945 12.6667 7.99967Z"
                fill="#476DD6"
              />
            </svg>

            <p class="mb-0 fs-12 txt-pri text-doctor-info max-line-2">{{dtr.majors || 'Chưa cập nhật'}}</p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="mb-3"
      @click="onSelectDoctor(2)"
    >
      <div class="doctor-add-btn">
        <svg
          width="29"
          height="28"
          viewBox="0 0 29 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.4997 25.6663C8.05635 25.6663 2.83301 20.443 2.83301 13.9997C2.83301 7.55635 8.05635 2.33301 14.4997 2.33301C20.943 2.33301 26.1663 7.55635 26.1663 13.9997C26.1663 20.443 20.943 25.6663 14.4997 25.6663ZM14.4997 4.66634C9.34502 4.66634 5.16634 8.84502 5.16634 13.9997C5.16634 19.1543 9.34502 23.333 14.4997 23.333C19.6543 23.333 23.833 19.1543 23.833 13.9997C23.833 8.84502 19.6543 4.66634 14.4997 4.66634ZM14.5002 7.88326C15.1445 7.88326 15.6669 8.4056 15.6669 9.04993V12.833H19.4494C20.0938 12.833 20.6161 13.3553 20.6161 13.9997C20.6161 14.644 20.0938 15.1663 19.4494 15.1663H15.6669V18.9494C15.6669 19.5938 15.1445 20.1161 14.5002 20.1161C13.8559 20.1161 13.3335 19.5938 13.3335 18.9494V15.1663H9.54993C8.9056 15.1663 8.38326 14.644 8.38326 13.9997C8.38326 13.3553 8.9056 12.833 9.54993 12.833H13.3335V9.04993C13.3335 8.4056 13.8559 7.88326 14.5002 7.88326ZM15.6669 13.283C15.4183 13.283 15.2169 13.0815 15.2169 12.833V9.04993C15.2169 8.65412 14.896 8.33326 14.5002 8.33326C14.1044 8.33326 13.7835 8.65412 13.7835 9.04993V12.833C13.7835 13.0815 13.5821 13.283 13.3335 13.283H9.54993C9.15412 13.283 8.83326 13.6039 8.83326 13.9997C8.83326 14.3955 9.15412 14.7163 9.54993 14.7163H13.3335C13.5821 14.7163 13.7835 14.9178 13.7835 15.1663V18.9494C13.7835 19.3452 14.1044 19.6661 14.5002 19.6661C14.896 19.6661 15.2169 19.3452 15.2169 18.9494V15.1663C15.2169 14.9178 15.4183 14.7163 15.6669 14.7163H19.4494C19.8452 14.7163 20.1661 14.3955 20.1661 13.9997C20.1661 13.6039 19.8452 13.283 19.4494 13.283H15.6669ZM3.28301 13.9997C3.28301 20.1945 8.30488 25.2163 14.4997 25.2163C20.6945 25.2163 25.7163 20.1945 25.7163 13.9997C25.7163 7.80488 20.6945 2.78301 14.4997 2.78301C8.30488 2.78301 3.28301 7.80488 3.28301 13.9997ZM4.71634 13.9997C4.71634 8.59649 9.09649 4.21634 14.4997 4.21634C19.9029 4.21634 24.283 8.59649 24.283 13.9997C24.283 19.4029 19.9029 23.783 14.4997 23.783C9.09649 23.783 4.71634 19.4029 4.71634 13.9997ZM2.83301 13.9997C2.83301 20.443 8.05635 25.6663 14.4997 25.6663C20.943 25.6663 26.1663 20.443 26.1663 13.9997C26.1663 7.55635 20.943 2.33301 14.4997 2.33301C8.05635 2.33301 2.83301 7.55635 2.83301 13.9997ZM5.16634 13.9997C5.16634 8.84502 9.34502 4.66634 14.4997 4.66634C19.6543 4.66634 23.833 8.84502 23.833 13.9997C23.833 19.1543 19.6543 23.333 14.4997 23.333C9.34502 23.333 5.16634 19.1543 5.16634 13.9997ZM15.6669 9.04993C15.6669 8.4056 15.1445 7.88326 14.5002 7.88326C13.8559 7.88326 13.3335 8.4056 13.3335 9.04993V12.833H9.54993C8.9056 12.833 8.38326 13.3553 8.38326 13.9997C8.38326 14.644 8.9056 15.1663 9.54993 15.1663H13.3335V18.9494C13.3335 19.5938 13.8559 20.1161 14.5002 20.1161C15.1445 20.1161 15.6669 19.5938 15.6669 18.9494V15.1663H19.4494C20.0938 15.1663 20.6161 14.644 20.6161 13.9997C20.6161 13.3553 20.0938 12.833 19.4494 12.833H15.6669V9.04993Z"
            fill="#20409B"
          />
        </svg>
        <p class="mb-0 txt-pri fs-16">Thêm</p>
      </div>
    </div>
  </div>
</template>

<script>
import appUtils from '../../utils/appUtils'
export default {
  name: 'CareTeamComponent',
  props: ['doctors', 'supporters', 'main_doctor'],
  methods: {
    getUrlImage (path) {
      if (!path) return
      return appUtils.getDocumentURL(path)
    },
    onSelectDoctor (t) {
      this.$emit('onSelectDoctor', t)
    },
    onDeleteDoctor (d) {
      this.$emit('onDeleteDoctor', d)
    }
  }
}
</script>

<style scoped>
.circle-num {
  width: 24px !important;
  height: 24px !important;
  min-width: 24px !important;
  min-height: 24px !important;
  background-color: #f3f3f4;
  border-radius: 12px;
}
.doctor-add-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 74px;
  width: 100%;
  border: 1px dashed #20409b;
  box-sizing: border-box;
  border-radius: 9px;
  cursor: pointer;
}
.doctor-item {
  padding: 14px;
  background-color: white;
  border-radius: 15px;
  margin-bottom: 16px;
}
.d-info-avatar {
  display: flex;
  width: calc(100% - 100px);
}
.d-status {
  width: 100px;
}
.avatar {
  height: 62px;
  width: 62px;
  border-radius: 12px;
  margin-right: 16px;
}
.text-doctor-info {
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0px;
  text-align: left;
  height: 34px;
}
</style>
